// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3njX7","label":"CategoryService_label__3Qio4","location":"CategoryService_location__STfhT"};